export const stage = process.env.REACT_APP_STAGE;
